export default __webpack_public_path__ + "static/media/nftDetailBgMb.14ecbd9e.png";